/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

export const gtmEventTypes = {
  SELECT_TITLE: 'FED-OL-ENQ-001',
  ENTER_FIRSTNAME: 'FED-OL-ENQ-002',
  ENTER_LASTNAME: 'FED-OL-ENQ-003',
  ENTER_PHONE: 'FED-OL-ENQ-004',
  ENTER_EMAIL: 'FED-OL-ENQ-005',
  ENTER_COMMENTS: 'FED-OL-ENQ-006',
  CHECK_OPTIN: 'FED-OL-ENQ-007',
  CHECK_PRIVACY_POLICY: 'FED-OL-ENQ-008',
  CLICK_PRIVACY_POLICY: 'FED-OL-ENQ-009',
  CLICK_SUBMIT: 'FED-OL-ENQ-010',
  CLICK_SUBMIT_WITH_DATA: 'FED-OL-ENQ-011',
  CLICK_BACK: 'FED-OL-ENQ-012',
}

// Action creators
export const gtmEvents = {
  [gtmEventTypes.SELECT_TITLE]: ({selection}) => ({
    type: gtmEventTypes.SELECT_TITLE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SELECT_TITLE,
    pageCategory: 'Outlet Store',
    pageAction: `Outlet Store Form - Selected "TITLE" - "${selection.toUpperCase()}"`,
  }),
  [gtmEventTypes.ENTER_FIRSTNAME]: () => ({
    type: gtmEventTypes.ENTER_FIRSTNAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_FIRSTNAME,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "FIRSTNAME"',
  }),
  [gtmEventTypes.ENTER_LASTNAME]: () => ({
    type: gtmEventTypes.ENTER_LASTNAME,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_LASTNAME,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "LASTNAME"',
  }),
  [gtmEventTypes.ENTER_PHONE]: () => ({
    type: gtmEventTypes.ENTER_PHONE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_PHONE,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "PHONE"',
  }),
  [gtmEventTypes.ENTER_EMAIL]: () => ({
    type: gtmEventTypes.ENTER_EMAIL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_EMAIL,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "EMAIL"',
  }),
  [gtmEventTypes.ENTER_COMMENTS]: () => ({
    type: gtmEventTypes.ENTER_COMMENTS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.ENTER_COMMENTS,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Store Form - Entered "COMMENTS"',
  }),
  [gtmEventTypes.CHECK_OPTIN]: () => ({
    type: gtmEventTypes.CHECK_OPTIN,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CHECK_OPTIN,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Form - Checked "OPTIN"',
  }),
  [gtmEventTypes.CHECK_PRIVACY_POLICY]: () => ({
    type: gtmEventTypes.CHECK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CHECK_PRIVACY_POLICY,
    pageCategory: 'Outlet Store',
    pageAction: 'Outlet Form - Checked "PRIVACYPOLICY"',
  }),
  [gtmEventTypes.CLICK_PRIVACY_POLICY]: ({buttonText}) => ({
    type: gtmEventTypes.CLICK_PRIVACY_POLICY,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_PRIVACY_POLICY,
    pageCategory: 'Outlet Store',
    pageAction: `Outlet Store Form - Clicked ${buttonText.toUpperCase()}`,
  }),
  [gtmEventTypes.CLICK_SUBMIT]: ({buttonText}) => ({
    type: gtmEventTypes.CLICK_SUBMIT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SUBMIT,
    pageCategory: 'Outlet Store',
    pageAction: `Outlet Store Form - Clicked "${buttonText.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_SUBMIT_WITH_DATA]: ({
                                             nameplate,
                                             bodyStyle,
                                             storeTypeCategory,
                                             grade,
                                             hasAccessories,
                                             fittedAccessories,
                                             dealerName,
                                           }) => ({
    type: gtmEventTypes.CLICK_SUBMIT_WITH_DATA,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_SUBMIT_WITH_DATA,
    pageCategory: 'Outlet Store',
    pageAction: `Outlet Store Form - Clicked Submitted - "${storeTypeCategory.toUpperCase()}", "${nameplate.toUpperCase()} ${bodyStyle.toUpperCase()}", "${grade.toUpperCase()}", ACCESSORIES "${hasAccessories.toUpperCase()}", "${fittedAccessories.toUpperCase()}" - ${dealerName.toUpperCase()}"`,
  }),
  [gtmEventTypes.CLICK_BACK]: ({buttonText}) => ({
    type: gtmEventTypes.CLICK_BACK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLICK_BACK,
    pageCategory: 'Outlet Store',
    pageAction: `Outlet Form - Clicked - Clicked "${buttonText.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/outlet-store-enquiry-form-duck.js